import React from 'react';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

import type { LocationResultsProps } from '../../LocationScreen.types';
import { LocationLayout as DesktopLocationLayout } from './LocationLayout.desktop';
import { LocationLayout as MobileLocationLayout } from './LocationLayout.mobile';

export const LocationLayout = (props: LocationResultsProps) => {
  const { currentBreakpoint } = useBreakpointHelpers();

  if (currentBreakpoint.isMobile) return <MobileLocationLayout {...props} />;

  return <DesktopLocationLayout {...props} />;
};
